import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import { styled } from "@mui/material";

const CustomizedButtonGroup = styled(ButtonGroup)(({ theme }) => {
  return {
    color: "rgba(0, 0, 0, 0.87) !important"
  };
});

const CustomizedButton = styled(Button)(({ theme }) => {
  return {
    fontSize: theme.typography.pxToRem(10),
    textTransform: "none",
    color: "inherit !important;",
    borderColor: "currentColor !important",
    "&:focus-visible": {
      // "--dsb-outline-color": "green",
      outline: theme.outline(),
      outlineOffset: "-2px"
    }
  };
});

function Disclaimer({ className, classes, showModal }) {
  function onClick(link) {
    return event => {
      showModal("IFRAME", { link, fullScreen: true });
    };
  }

  return (
    <CustomizedButtonGroup className={className} variant="text" size="small" disableRipple disableFocusRipple>
      <CustomizedButton onClick={onClick("imprint")}>Impressum</CustomizedButton>
      <CustomizedButton onClick={onClick("usage_rights")}>Nutzungsbedingungen</CustomizedButton>
      <CustomizedButton onClick={onClick("privacy")}>Datenschutz</CustomizedButton>
      <CustomizedButton onClick={onClick("contact")}>Kontakt</CustomizedButton>
    </CustomizedButtonGroup>
  );
}

Disclaimer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object,
  showModal: PropTypes.func.isRequired
};

export default Disclaimer;
